module.exports = __webpack_public_path__ + "static/media/rm_06-25.4faba508.png";